module.exports = __webpack_public_path__ + "img/icon1.2bf99e25.svg";